import React from 'react'
import { Table, Menu, ActionIcon, Text, NumberFormatter } from '@mantine/core'
import { IconDotsVertical, IconInfoCircle } from '@tabler/icons-react'

const ActionMenu = ({ handleAction }) => {
  return (
    <Menu width={180} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconInfoCircle stroke={1.5} size={14} />}
          onClick={() => handleAction('balance')}
          fw='600'
          fz={11}
        >
          Detail Balance
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableReferralList = ({ label, data, actionMethod }) => {

  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.id}</Table.Td>
        <Table.Td>{val.name || '-'}</Table.Td>
        <Table.Td>{val.email || '-'}</Table.Td>
        <Table.Td>{val.phone || '-'}</Table.Td>
        <Table.Td>{val.commision_orders || 0}</Table.Td>
        <Table.Td>
          <Text fz={13} c='black'>
            <NumberFormatter
              prefix={'IDR. '}
              thousandSeparator=","
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale={true}
              value={val.balance || 0} 
            />
          </Text>
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableReferralList